import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getOBDIICode',
    standalone: false
})
export class GetOBDIICode implements PipeTransform {
  transform(sourceAddress: string, faultCode: string): string {
    let code: string = '';
    const decimalNumber = new Number(faultCode);
    let hex = decimalNumber.toString(16);
    if (sourceAddress) {
      switch (sourceAddress) {
        case '500':
          code = 'B';
          break;
        case '501':
          code = 'C';
          break;
        case '502':
          code = 'P';
          break;
        case '503':
          code = 'U';
          break;
      }

      // A DTC is four digits. Hex drops leading zeros, so fault code 272 would
      // read P110 instead of P0110.
      return code + hex.toUpperCase().padStart(4, '0');
    }
  }
}
